var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataSortingNumericAscending = function SvgDataSortingNumericAscending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 2 5 3.455v1.613l2-.703V10h2V2zM16 2v16h-3l4 4 4-4h-3V2zM7 13c-1.333 0-2.275.814-2.645 1.553C3.986 15.29 4 16 4 16h2s.014-.291.144-.553c.131-.261.19-.447.856-.447.667 0 .725.186.855.447C7.986 15.71 8 16 8 16c0 .036-.09.33-.389.684s-.752.753-1.217 1.105a17 17 0 0 1-1.873 1.225L4 19.297V21h6v-2H8.02c.39-.321.79-.637 1.119-1.027.45-.535.86-1.156.86-1.973 0 0 .015-.709-.355-1.447C9.275 13.814 8.334 13 7 13"
  })));
};
export default SvgDataSortingNumericAscending;